import React, { useState } from "react";
import TblCard from "common/components/TblCard";

const MobileList = ({ COLUMNS, dataJson, searchKey }) => {

    return (
        <div>
            {dataJson.map((val, index) => {
                return (
                    <div className="my-class" key={index}>
                        <TblCard COLUMNS={COLUMNS} dataJson={val} searchKey={searchKey} />
                    </div>
                );
            })}
        </div>
    );
};

export default MobileList;
